module.exports = __webpack_public_path__ + "static/media/btg.d8780bd0.jpg";